import React from "react";
import {
  Datagrid,
  List,
  TextField,
  DateField,
  Filter,
  TextInput,
  ReferenceField
} from "react-admin";

const PeriodFilter = (props) => (
    <Filter {...props}>
      <TextInput label='شماره تلفن' source="phoneNumber" alwaysOn/>
      <TextInput label='ایمیل' source="email" alwaysOn/>
    </Filter>
);

export const PeriodList = (props) => (
  <List {...props} filters={<PeriodFilter/>} perPage={15}>
    <Datagrid>
      <TextField source="objectId"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="startDate"/>
        <DateField showTime={true} locales={"fa-IR"} source="endDate"/>
        <TextField source="note"/>
        <ReferenceField link="show" label="نام" source="userId" reference="user">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="userId"/>
    </Datagrid>
  </List>
);